import { Navigate } from "react-router-dom";
import useBusiness from "@/core/business/use-business";
import { ONBOARDING_STEP } from "@/onboarding/constants";
import PostOnboardingItems from "./post-onboarding/post-onboarding-items";
import WaitingPageLayout from "./waiting-page-layout";

const WaitingForSetup = () => {
  const { selectedBusiness } = useBusiness();

  const isOnboardingComplete =
    selectedBusiness &&
    selectedBusiness.onboarding_step === ONBOARDING_STEP.completed;

  if (isOnboardingComplete) {
    return <Navigate to="/" />;
  }

  return (
    <WaitingPageLayout
      headline="Volca is almost ready"
      body="Someone at your company is finishing setup. You'll have access as soon as they're done."
    >
      <PostOnboardingItems />
    </WaitingPageLayout>
  );
};

export default WaitingForSetup;
